import { FC } from 'react';
import Button from './Button';
import { RefactoredButtonProps } from './button-props';
import { useAsyncClick } from '../hooks/useAsyncClick';
import { LoadingDots } from '../Loading';

const SaveButton: FC<RefactoredButtonProps & { [key: string]: any }> = ({
  title,
  onClick,
  onClickAsync,
  enabled = true,
  isWorking = false,
  preventDoubleClick = true,
  ...otherProps
}) => {
  const { run, isRunning } = useAsyncClick(
    async (e?: any) => {
      if (onClickAsync) await onClickAsync(e);
    },
    { debounceMs: 500 }
  );
  const working = isWorking || (preventDoubleClick && isRunning);
  const canClick = enabled && !working;
  return (
    <Button
      size="xs"
      color={canClick ? 'success' : 'disabled'}
      onClick={(e) => (onClickAsync ? run(e) : onClick && onClick(e))}
      disabled={!canClick}
      {...otherProps}
    >
      {working ? <LoadingDots color="white" /> : title}
    </Button>
  );
};

export default SaveButton;
